import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section id="bonos" className="defer-paint w-full scroll-mt-6 bg-coal py-12 sm:py-14" aria-labelledby="bonuses-heading" data-id="element-13" data-mp="gx6poafu4kc1">
      <div className="mx-auto max-w-5xl px-6" data-id="element-14" data-mp="qu304lpangj8">
        <SectionHeading eyebrow="Para entrenadores de atletismo" title={<span id="bonuses-heading" data-id="element-16" data-mp="14s9n36spfw44">+ 5 bonos exclusivos</span>} lead="Herramientas tácticas para resolver situaciones reales en la pista." data-id="element-15" data-mp="qs8e142adidk" />

        {/* Dos por renglón y una sola línea de beneficio por bono: la sección
            se mantiene corta y el peso visual queda en las portadas. */}
        <ul className="mt-9 grid grid-cols-2 gap-3 sm:gap-4" data-id="element-17" data-mp="19kt0a2nhcp8e">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col gap-3 rounded-2xl border border-line bg-ink p-3.5 sm:flex-row sm:items-center sm:gap-5 sm:p-5" data-id="element-18" data-mp="1nklqzxz0b5gd">
              <img src={bonus.image} alt={bonus.alt} className="h-auto w-16 shrink-0 self-start rounded-lg object-cover sm:w-24 sm:self-center sm:rounded-xl" width={1024} height={1024} sizes="96px" loading="lazy" decoding="async" data-id="element-19" data-mp="3ps4x2j7r135f" />

              <div className="min-w-0 flex-1" data-id="element-20" data-mp="cj0k8x68etap">
                <div className="flex items-center gap-2.5" data-id="element-21" data-mp="chz4wgi6nkn6">
                  <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.2em] text-stone" data-id="element-22" data-mp="gju7rpfri632">
                    Bono {bonus.number}
                  </p>
                  <span className="shrink-0 rounded-full bg-gold px-2 py-0.5 font-sans text-[9px] font-bold uppercase tracking-[0.14em] text-ink" data-id="element-23" data-mp="qbgep9l2hj00">
                    Gratis
                  </span>
                </div>

                <h3 className="mt-2 font-display text-lg font-bold leading-snug text-ivory sm:text-xl" data-id="element-24" data-mp="10a60vejzxpm2">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 font-sans text-[0.8rem] leading-relaxed text-stone" data-id="element-25" data-mp="5me5s0yk4gwb">
                  {bonus.tagline}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}